import Header from "../../Home/Header";
import Footer from "../../Home/Footer";

function Fables () {
  return (
    <div className="core">
      <Header />
      <h2 className="bloc titre">Fables anciennes</h2>
      <div className="bloc">
      <h3>1883 : Un pendu à dépendre</h3>
        <p>En 1883, Charles Quint était représenté par le notaire Van Damme et les trois Auvergnats étaient Joseph Bouilliez, Alfred Quertain et Henri Boiteux</p>
        <p>« Ce dernier a dû garder de cette époque un souvenir ineffaçable, car il s’en fallut de peu qu'il ne fût pendu tout de bon ! Au moment de l'heure suprême, on coupait la corde et nos pendus tombaient dans un tombereau. Cela s’accompagnait, bien entendu, d'une «Brabançonne» vigoureuse. Advint-il qu'un musicien trop ému fit un «couac» retentissant ? Toujours est-il que, ce jour-là, les chevaux de l'escorte prirent peur; il y eut une panique dans la foule et parmi les acteurs, si bien qu'on en avait oublié de dépendre le ci devant Henri Boiteux qui en réchappa tout de même, mais préféra borner là ses talents de tragédien.</p>
        <p>Allez-vous faire conter cette aventure par des vieux de Beaumont qui ne manqueront pas de l'assaisonner, et vous n'aurez pas perdu votre temps."</p>
        <p>Ce fait divers fut conté par Monsieur L. Lebrun à un journaliste en 1937.</p>
        <p>Extrait de Bonjour n° 8 du 15 août 1937.</p>
      <h3>1931 : Un bouffon pas sérieux</h3>
        <p>Le dossier de l’organisation de la reconstitution de 1931 comporte la correspondance échangée entre le bouffon du Roi (Mr Léopold Busine) et le comité d'organisation.</p>
        <p>Nous ne pouvons résister au plaisir de reproduire in extenso ces trois lettres qui ne manquent point d'humour, deux sont des documents authentiques, (celle de Mr Busine) la troisième est le brouillon de la réponse du comité que l'on peut supposer comme exacte.</p>
        <p>Beaumont, le 14 juin 1931</p>
        <p>«Messieurs les Membres du Comité Charles Quint,</p>
        <p>D'après certains bruits qui courent en ville concernant le remplaçant du bouffon du Roi, je n'ai jamais refusé de le faire. L'année dernière, je l'ai fait avec plaisir, vous avez pu vous tous en juger.
Je suis cette année. Messieurs, encore prêt à remplir mon rôle comme avant, mais j'espère bien que cela mérite au moins une récompense.
</p>
 <p> Recevez, Messieurs, mes bien sincères salutations.</p>
 <p>Léopold Busine »</p>
<p>Réponse du comité en date du 16 juin 1931.</p>
<p>« En séance du 16 juin 1931, le comité ayant pris connaissance de votre lettre me prie de vous répondre ce qui suit et j'espère toujours votre collaboration comme bouffon du Roi au cortège Charles Quint.</p>
<p>Quant à la récompense que vous demandez, vu l'état de nos ressources, il nous est impossible d'accéder à votre sollicitation.</p>
<p>J'espère que vous comprendrez. »</p>
<p>Monsieur Busine a répondu au Comité en date du 18 juin 1931.</p>
<p>Beaumont, le 18 juin 1931</p>
<p>«Messieurs les Membres du Comité Charles Quint,</p>
<p> Si vos ressources ne vous le permettent pas, mes jambes ne les permettent pas non plus.</p>
<p>Donc inutile de compter sur moi pour ce jour-là.</p>
<p> Mes bien sincères salutations. »</p>
<p>Quand on vous disait que le bouffon n'avait pas fini de nous faire rire !</p>
    

      </div>
      <Footer />
    </div>
  )
}

export default Fables